// Ad Zone
const ADZONE_DOMAIN = 'a.trkgenix.com'

export const adZone = {
  footerSmBase: `//${ADZONE_DOMAIN}/loader?a=1036&s=135&t=21&p=242`,
  footerLgBase: `//${ADZONE_DOMAIN}/loader?a=1038&s=135&t=20&p=242`,
  headerSmBase: `//${ADZONE_DOMAIN}/loader?a=1035&s=135&t=22&p=242`,
  headerLgBase: `//${ADZONE_DOMAIN}/loader?a=1037&s=135&t=20&p=242`,
  sidebarCamsBase: `//${ADZONE_DOMAIN}/loader?a=1033&s=135&t=77&p=242`,
  sidebarDatingBase: `//${ADZONE_DOMAIN}/loader?a=1032&s=135&t=86&p=242`,
  sidebarGamesBase: `//${ADZONE_DOMAIN}/loader?a=1034&s=135&t=92&p=242`,
  popunderBase: `//${ADZONE_DOMAIN}/oauth2?id=529`,
  interstitialBase: `//${ADZONE_DOMAIN}/posty?id=1031`,
}

// FreshChat / Freshdesk
const FRESHCHAT_TOKEN = '98a0a2f9-e360-495e-9f36-c88b0addb4ee'

export const freshChat = {
  token: FRESHCHAT_TOKEN,
  host: 'https://cdncloud-help.freshchat.com',
  widgetUuid: 'd4767699-f7df-417d-8031-22f6e2cad441',
  freshdeskWidgetUrl: 'https://widget.freshworks.com/widgets/9000000934.js',
}

// reCAPTCHA
export const recaptcha = {
  siteKey: '6LckS4AqAAAAANu8ADL3vzb7t5LyLO5PvmieX6BE',
}

// Google OAuth
export const google = {
  oauthClientId:
    '49889973396-1mklb7sakkn7mkkjrd4h947hsfnnf0t8.apps.googleusercontent.com',
}
